const NAME_SPACE = 'NavigationMobile';

export { NAME_SPACE };
